import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import App from './App'
import ReactGA from "react-ga4"

ReactGA.initialize("G-W9M76MPZB6"); 

const container = document.getElementById('root'); 
const root = ReactDOMClient.createRoot(container); 
root.render(<App tab="profile"/>);